import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { cloudloyalty } from "Services/Apis/clients";

export const getProductAvailability = createAsyncThunk(
  "product/getAvailability",
  async ({ productSku, originalId, vendorId }, { getState, rejectWithValue }) => {
    try {
      const { user } = getState().oidc;

      const { data } = await cloudloyalty(user).get(`/v1/products/skus/${productSku}/availability?originalId=${originalId}&vendorId=${vendorId}`);

      return data;
    } catch (err) {
      console.log(err);

      rejectWithValue(err);
    }
  }
)

const initialState = {
  productAvailabilityData: null,
  isProductAvailabilityLoading: false,
  productAvailabilityHasError: false,
};

const productAvailabilitySlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    resetProductAvailabilityData: (state) => {
      state.productAvailabilityData = null;
      state.isProductAvailabilityLoading = false;
      state.productAvailabilityHasError = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProductAvailability.pending, (state) => {
      state.isProductAvailabilityLoading = true;
    })

    builder.addCase(getProductAvailability.fulfilled, (state, action) => {
      state.isProductAvailabilityLoading = false;
      state.productAvailabilityData = action.payload;
    })

    builder.addCase(getProductAvailability.rejected, (state) => {
      state.isProductAvailabilityLoading = false;
      state.productAvailabilityHasError = true;
    })
  }
})

export const { resetProductAvailabilityData } = productAvailabilitySlice.actions;
export default productAvailabilitySlice.reducer;
